export const PAGE_ID = 'retention'

export const FORM_MAP = {
  RANGE_TIME: 'rangeTime',
  RANGE_TIME_DIFF: 'diff',
  RANGE_TIME_TYPE: "timeType",
  ZONE: 'zone',
  REGION: 'region',
  SYSTEM: 'system',
  CHANNEL: 'channel',
  TIME_TYPE: 'timeType',
  LANGUAGE: 'language',
}

export const METRICS_COLORS = ['#5086F3','#77E097','#6A7597','#F8CC6A','#A08FF2','#5EC8F1','#CF61AC','#F19E55','#387F7D','#F17C86','#8EB9FF'];
/**
 * RetentionTable组件 tag属性的值.
 */
export const TABLE_TAG = {
  NEW: 'new',
  ACTIVE: 'active'
}

export const TAB_ID_NEW_USERS = 'new';
export const TAB_ID_ACTIVE_USERS = 'active';
export const TAB_ID_RETENTION_USERS = 'retention';
export const TAB_ID_RETURN_USERS = 'return';

// tab切换
export const TABS = [
  { id: TAB_ID_NEW_USERS, label: 'New Users', pageId: '130001', pageName: 'retentionIndexNewUsers', pagePath: '/retention/index/new' },
  { id: TAB_ID_ACTIVE_USERS, label: 'Active Users', pageId: '130002', pageName: 'retentionIndexActiveUsers', pagePath: '/retention/index/active' },
  // { id: TAB_ID_RETENTION_USERS, label: 'Retention Users', pageId: '130003', pageName: 'retentionIndexRetentionUsers', pagePath: '/retention/index/retention' },
  // { id: TAB_ID_RETURN_USERS, label: 'Return Users', pageId: '130004', pageName: 'retentionIndexReturnUsers', pagePath: '/retention/index/return' },
];

/**
* Key Days 默认值
*/
export const KEY_DAYS_DEFAULT_VALUE = 0


/**
* Key Days 筛选器选项组
*/
export const KEY_DAYS_OPTIONS = [
{
  value: 0,
  text: "Key Days",
  tooltip: "",
},
{
  value: 30,
  text: "2 ~ 30 Days",
  tooltip: "",
},
{
  value: 60,
  text: "2 ~ 60 Days"
},
{
  value: 90,
  text: "2 ~ 90 Days"
}

];

export const LINE_CHART_TITLE = {
  new: 'New',
  active: 'Active',
}

export const DATE_FORMAT = {
    Day: "YYYY-MM-DD",
    Week: "YYYY-MM-DD",
    Month: "YYYY-MM",
}

export  { timeRange } from '@/pages/dashboard/pages/engagement/_config'
